import styled from 'styled-components';

const SectionLinksRowWrapper = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-evenly;
  flex: 1;
  margin-top: 10px;
`;

export default SectionLinksRowWrapper;
